<template>
  <div>
      <!-- Tabela -->

        <v-card class="">
            <v-card-title>
                {{$t('areas')}}
                <v-spacer></v-spacer>
                <v-text-field v-model="search" append-icon="mdi-magnify" :label="$t('provider_dashboard.search')" single-line hide-details :items-per-page="5"></v-text-field>
            </v-card-title>
            <v-data-table v-model="selectedAreas" :item-key="itemKey" :headers="headers" show-select :items="areas ? areas : []" :search="search" :loading='loading'>
           
            </v-data-table>

            <v-card-actions>

                <!-- Botão de Deletar  -->

                <v-btn :loading='loading' :disabled='!selectedAreas.length' color='error' class="btn-block btn-delete" @click="removeAreas" > 
                    <v-icon class="mr-2">mdi-close</v-icon> 
                    <span>{{$t('delete')}}</span>
                </v-btn>

                <v-spacer></v-spacer>

                <!-- Botão de Salvar  -->

                <v-btn :loading='loading' color='primary' class="btn-block btn-save" @click="saveAreas" > 
                    <v-icon class="mr-2">mdi-check</v-icon> 
                    <span>{{$t('save')}}</span>
                </v-btn>

            </v-card-actions>

        </v-card>
  </div>
</template>

<script>

import { mapActions } from 'vuex'
import vueI18n from '../../../../plugins/vue-i18n'
import { REMOVE_PREVIEW_AREA, SAVE_AREA } from '../../../../store/mutations'

export default {

    name: 'PreviewAreaTabelData',

    data() {
        return {

            selectedAreas: [],
            search: '',
            loading: false

        }
    },

    props: ['areas', 'itemKey'],

    computed: {

        headers() {
            return [
                { text: vueI18n.t('provider_dashboard.name_h'), value: 'name' },
            ]
        },
    },

    methods: {

        ...mapActions({ removeSelected: `AreaVuex/${REMOVE_PREVIEW_AREA}`, save: `AreaVuex/${SAVE_AREA}` }),

        removeAreas() {

            this.loading = true

            try {

                this.removeSelected(this.selectedAreas)

                this.showToast(this.$t('areas_dashboard.deleted_areas_msg'), this.$t('areas_dashboard.deleted_areas_title'), 'success')

                this.selectedAreas = []

            } catch (error) {

                this.showToast(error.message, this.$t('error'), 'error')

            } finally {

                this.loading = false

            }

        },

        async saveAreas() {

            this.loading = true

            try {

                const { notSaved } = await this.save(this.areas)

                this.showToast(this.$t('areas_dashboard.saved_areas_msg'), this.$t('areas_dashboard.saved_areas_title'), 'success')

                this.selectedAreas = []

                const joined = notSaved.join()

                const replaced = joined.replaceAll(",", ", ")

                this.showToast(`${replaced}`, this.$t('areas_dashboard.not_saved_areas_title'), 'warning', { 
                
                    position: 'center',
                    timeout: 20000,
                
                })

                this.$emit('saved')

            } catch (error) {

                this.showToast(error.message, this.$t('error'), 'error')

            } finally {

                this.loading = false

            }

        }

    },
}
</script>

<style>

</style>